import React, { useContext, useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { AppDispatchContext } from "../../App";

export default function AdminHeader() {
  const navigate = useNavigate();
  const dispatch = useContext(AppDispatchContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [userData, setUserData] = useState(null);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch({ type: "logout" });
    navigate("/");
    handleCloseMenu();
  };

  useEffect(() => {
    const data = localStorage.getItem("user_data");
    if (data) {
      setUserData(JSON.parse(data));
    }
  }, []);

  return (
    <AppBar position="fixed" sx={{ bgcolor: "#1f2937" }}>
      <Toolbar
        sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
      >
        {/* Back Button */}
        <Button
          startIcon={<ArrowBackIcon />}
          sx={{ color: "white", textTransform: "none" }}
          onClick={() => navigate("/")}
        >
          Back
        </Button>

        {/* Center: Admin Panel Title */}
        <Button
          sx={{ color: "white", textTransform: "none" }}
          onClick={() => navigate("/admin-dashboard")}
        >
          <Typography variant="h6">Admin Panel</Typography>
        </Button>

        {/* Right Side Buttons + Avatar */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{ color: "white", borderColor: "white", textTransform: "none" }}
            onClick={() => navigate("/scripts")}
          >
            Scripts Dashboard
          </Button>

          <Button
            variant="outlined"
            sx={{ color: "white", borderColor: "white", textTransform: "none" }}
            onClick={() => navigate("/wordcontent")}
          >
            Word Content
          </Button>

          {/* User Info + Avatar */}
          <Box className="flex items-center gap-3 ml-10">
            <span className="text-sm text-gray-300 font-medium truncate">
              {userData?.username || "teacher"}
            </span>

            <Avatar
              // src="/admin-pic.png"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTHfd3PPulVSp4ZbuBFNkePoUR_fLJQe474Ag&s"
              onClick={handleAvatarClick}
              className="cursor-pointer"
              sx={{ width: 40, height: 40 }}
            />
          </Box>

          {/* Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem >Settings</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

